module.exports = __webpack_public_path__ + "3b3203944862d1e62dd76cbcd9a66475.glb";